export const TITLE = 'Shifts Information';
export const DB_PREFIX = 'shiftsInfo';
